// src/i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  .use(HttpBackend) // load translation files
  .use(LanguageDetector) // detect user language
  .use(initReactI18next) // initialize react-i18next
  .init({
    fallbackLng: 'pt-BR',
    debug: true,
    interpolation: {
      escapeValue: false, // not needed for React
    },
    backend: {
      loadPath: '/locales/{{lng}}/translation.json' // path to translation files
    }
  });

export default i18n;
